module.exports = __webpack_public_path__ + "images/emoji/snake.4dd839e14d973cff2223.png";